export default {
  gmv: '提单交易额',
  paidGmv: '支付交易额',
  grossRevenue: '销售额',
  orders: '订单量',
  paidOrders: '支付订单量',
  visitors: '访客数',
  buyers: '活跃买家数',
  buyers2: '提交订单买家数',
  paidBuyers: '付费买家数',
  cvr: '订单转化率',
  paidCVR: '付费转化率',
  byDay: '按天',
  byWeek: '按周',
  byMonth: '按月',
  days: '天',
  weeks: '周',
  months: '月',
  yesterday: '昨日',
  thisWeekMonYesterday: '本周（周一到昨天）',
  lastWeekMonSun: '上周（周一到周日）',
  last7days: '最近7天',
  last14days: '最近14天',
  storeReport: '店铺报表',
  productReport: '商品报表',
  region: '国家站',
  skuId: 'Sku ID',
  search: '搜索',
  export: '导出',
  comparisonPeriod: '对比日期',
  statisticsPeriod: '统计周期',
  pageViews: '访问量',
  paidQty: '付费销量',
  ordersQty: '提交订单销量',
  productInfo: '商品信息',
  operation: '操作',
  details: '详情',
  timeSeries: '时间走势',
  dateTable: '数据表',
  exportData: '导出数据',
  selectDate: '自定义日期',
  storePerformance: '店铺绩效',
  preferredSeller: '优选店铺项目',
  preferred: '优选',
  excellent: '优秀',
  good: '良好',
  goodToImprove: '有待改进',
  bad: '不及格',
  metricsDidNotMeetTarget: '个指标未达标。请查看下面指标完成情况，以提升店铺绩效。',
  performBetterToFulfill: '仅需满足',
  moreCriteriaToJoin: ' 项条件，您就能自动加入优选店铺项目并获得相关特权奖励。',
  salesPerformance: '销售绩效',
  fulfillmentPerformance: '履约绩效',
  customerServicePerformance: '客服绩效',
  metricFailed: '个指标未达标',
  viewDetails: '查看项目详情',
  view: '查看',
  metricsDetails: '绩效指标明细',
  metrics: '指标项',
  myStore: '我的表现',
  target: '目标',
  status: '状态',
  action: '行动',
  uniqueVisitors: '独立访客数',
  ordersNum: '订单数',
  sequentialOrderGrowthRate: '订单环比增长率',
  meet: '达标',
  fail: '未达标',
  meetFulfillment: '满足',
  failFulfillment: '未满足',
  howToImprove: '如何提升',
  preFulfillmentCancelRate: '履约前取消率',
  lateDispatchingRate: '迟发率',
  fastDispatchingRate: '快发率',
  negativeRatingRate: '负面评论率',
  sellerFaultAppealRate: '卖家原因售后仲裁率',
  chatEffectiveResponseRate: 'Chat有效响应率',
  thePreferredSellerProgram: '“优选店铺”这个项目是平台对绩效表现好的店铺进行奖励的项目。平台将给予加入优选店铺项目的店铺有一定的特权，从而可以提升其收入。',
  congratulations: '恭喜!',
  yourStoreKeepGood: `您店铺的出色表现，赢得了本周“优选店铺”的特权奖励。继续保持出色表现！`,
  preferredSellerProgram: '优选店铺项目',
  criterias: '必要条件',
  criteriasA: '条件 A',
  criteriasB: '条件 B',
  criteriasC: '条件 C',
  meetAllPerformanceTargets: '所有绩效指标均达标',
  noLessThanExpanded: '自店铺开店或拓展至今至少 ',
  noLessThanExpanded2: ' 天',
  yourStorePoints: `店铺当前累计扣分不超过 `,
  yourStorePoints2: ` 分`,
  gainFollowingPrivileges: `当以上条件均满足时，您的店铺将获得以下特权奖励，从而提升您的销售`,
  knowMoreAboutPrivileges: '特权奖励说明 ',
  privilegeA: '特权 A',
  privilegeB: '特权 B',
  privilegeC: '特权 C',
  displayThePreferredRate: '将在搜索结果页和您的商品详情等场景里打上「优选店铺」标签来提升客户信任，从而提升访客的购买转化率。',
  increaseSearchRanking: `提升您店铺的商品在搜索推荐或品类商品列表上的排名`,
  grantAdvertisingBill: `将一次性给予 `,
  grantAdvertisingBill2: ` 先令的站内广告推广金，您可以用来支付您在平台的广告费。`,
  close: '关闭',
  uniqueVisitorsTip: '最近4周里访问过店铺商品详情的独立用户数。每周一更新。',
  ordersTip: '最近4周里被买家支付的订单数。每周一更新。',
  sequentialOrderGrowthRateTip: '最近4周被买家支付的订单数相对之前4周的增长率。每周一更新。',
  preFulfillmentCancelRateTip: '计算最近第2至5周买家支付了且未被其取消的非FBK订单中，因卖家自主取消或因卖家超时未发货或物流未揽收而取消的订单比例。每周一更新。',
  lateDispatchingRateTip: '计算最近第2至5周买家支付了且未被其取消的非FBK订单中，没有在规定时间以内（DS: 120小时, GS: 168小时）将包裹交付给平台物流的订单比例。每周一更新。',
  fastDispatchingRateTip: '计算最近第2至5周买家支付了且未被其取消的非FBK订单中，在较快时间以内（DS: 24小时, GS: 72小时）将包裹交付给平台物流的订单比例。每周一更新。',
  negativeRatingRateTip: '计算最近8周内，除配送服务评分外的所有买家订单评分中，1/2星评价的比例。每周一更新。',
  sellerFaultAppealRateTip: '计算最近8周内经平台仲裁确认为卖家责任的售后单数量与总确认售后单数量的比例。每周一更新。',
  chatEffectiveResponseRateTip: '计算最近4周内买家发起聊天后，卖家在规定时限内（根据聊天发起时间不同而定）首次有效回复的比例。每周一更新。',
  average: '平均',
  lastXWeeks: '最近 {0} 周',
  lastXMonths: '最近 {0} 月',
  noData: '无数据',
  store: '我的店铺',
  setTarget: '设定目标'
}
